import { notification } from "antd";
import { ApolloError } from "apollo-boost";
import { action, makeAutoObservable, runInAction } from "mobx";
import { Api } from "../../common/Api";
import { FamilyStore } from "./FamilyStore";

export class UpdateChildStore {
  store: FamilyStore;
  showDlg = false;
  loading = false;
  saving = false;
  child: any = null;
  orgs: any[] = [];
  loadingSchool = false;
  keyword = "";

  schoolId: string | undefined = undefined;
  id?: string = undefined;

  constructor(store: FamilyStore) {
    makeAutoObservable(this, {});
    this.store = store;
    // this.init();
  }

  @action show(id) {
    this.id = id;
    this.showDlg = true;
    this.loading = true;
    Api.child
      .get(id)
      .then((res) => {
        runInAction(() => {
          this.child = res.data.child;
          this.schoolId = this.child.school.id;
          this.orgs = [this.child.school];
        });
      })
      .finally(() => (this.loading = false));
  }

  @action save(values) {
    this.saving = true;
    return Api.family
      .updateChild({ ...values, id: this.id })
      .then((res) => {
        notification.success({
          message: `Success!`,
        });
        runInAction(() => {
          this.showDlg = false;
          this.store.loadData();
        });
      })
      .catch((err: ApolloError) => {})
      .finally(() => (this.saving = false));
  }

  @action close() {
    this.showDlg = false;
  }

  @action init() {
    Api.org.orgDict({}).then((res) => {
      this.orgs = res.data.orgs.items;
    });
  }

  get grades() {
    return this.orgs.find((x: any) => x.id === this.schoolId)?.grades || [];
  }

  @action onSchool(val) {
    this.schoolId = val;
  }

  @action
  setKeyword(val) {
    this.keyword = val;

    if (!this.keyword.trim()) {
      this.orgs = [];
      this.loadingSchool = false;
      return;
    }

    this.loadingSchool = true;
    Api.org
      .orgDict({ keyword: val })
      .then((res) => {
        runInAction(() => {
          this.orgs = res.data.orgs.items;
        });
      })
      .finally(() => {
        this.loadingSchool = false;
      });
  }
}
